/* eslint-disable */
export class WebSocketClient {
	constructor(url, logger) {
		this.url = url;
		this.logger = logger;
		this._log = this._log.bind(this);
		this.ws = null;
		this.counter = 0;
		this.maxReconnectionAttempts = 10;
		this.reconnectInterval = 5e3; // ms
		this.close = this.close.bind(this);
		this.NORMAL_CLOSE = 4001; // e.g. when user logs out: ws.close(4001, "session ended.");
	}

	_log(additionalData) {
		const data = {
			...additionalData,
			userAgent: navigator.userAgent,
			url: window.location.href
		};

		if (this.logger) {
			this.logger({ ...data });
		}
	}

	close(code, reason) {
		if (code && (code < 4000 || code > 4999)) {
			console.error(
				'The error code must be between 4000 and 4999. See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent'
			);
		}
		if (this.ws && this.ws.readyState === WebSocket.OPEN) {
			this.ws.close(code, reason);
		} else {
			console.warn(
				'Attemping to close a non existing Websocket or Websocket is not currently in open state.'
			);
		}
	}

	async connect(getTokenCallback, onOpenCallback, onMessageCallback) {
		const { OPEN, CONNECTING, CLOSING } = WebSocket;
		if (this.ws && [OPEN, CONNECTING, CLOSING].includes(this.ws.readyState)) {
			return;
		}
		const token = await getTokenCallback();
		this.ws = new WebSocket(`${this.url}/${token}`);
		this.counter += 1;

		this.ws.onopen = () => {
			this._log({ msg: 'websocket connected.', connectionAttempts: this.counter });
			if (onOpenCallback) {
				onOpenCallback();
			}
		};

		this.ws.onmessage = (e) => {
			if (onMessageCallback) {
				onMessageCallback(JSON.parse(e.data));
			}
		};

		this.ws.onclose = (e) => {
			this.ws = null; // prevent memory leak
			const { code, reason } = e;
			this._log({ code, reason, msg: 'Websocket closed' });

			// User logged out. This is a normal close
			if (e.code === this.NORMAL_CLOSE) {
				this.counter = 0;
				return;
			}
			if (this.counter < this.maxReconnectionAttempts) {
				setTimeout(
					() =>
						this.connect(
							getTokenCallback,
							onOpenCallback,
							onMessageCallback
						),
					this.reconnectInterval
				);
			} else {
				this._log({
					msg: 'User inactive for > 10 mins. Websocket closed as expected.',
					connectionAttempts: this.counter
				});
			}
		};

		this.ws.onerror = () => {
			this.ws = null; // prevent memory leak
			this._log({
				msg: 'Websocket closed unexpectedly. Attempting to reconnect in 5 seconds.'
			});

			if (this.counter < this.maxReconnectionAttempts) {
				setTimeout(
					() =>
						this.connect(
							getTokenCallback,
							onOpenCallback,
							onMessageCallback
						),
					this.reconnectInterval
				);
			}
		};
	}
}
